export default [
  {
    path: '/policy-manage',
    name: 'policy-manage',
    component: resolve => require(['views/policy-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/policy-form/:policyType/:isEdit/:id',
    name: 'policy-form',
    props: true,
    component: resolve => require(['views/policy-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '政策规则管理/政策规则', isForm: true }
  },
  {
    path: '/policy-detail/:type/:id',
    props: true,
    name: 'policy-detail',
    component: resolve => require(['views/policy-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '政策规则管理/政策规则详情' }
  },
  {
    path: '/integral-policy-manage',
    name: 'integral-policy-manage',
    component: resolve => require(['views/policy-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/policy-form/:policyType/:isEdit/:id/:isIntegral',
    name: 'policy-form',
    props: true,
    component: resolve => require(['views/policy-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分政策规则管理/积分商品政策规则', isForm: true }
  },
  {
    path: '/policy-detail/:type/:id/:isIntegral',
    props: true,
    name: 'policy-detail',
    component: resolve => require(['views/policy-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '积分政策规则管理/积分商品政策规则详情' }
  }
]
